import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import CssBaseline from '@mui/material/CssBaseline';

import { isFeatureEnabled } from 'ff/common/ffAppUtils';

import { createStore } from './store';
import { DebriefApp } from './app';
import SharedDebriefApp from 'ff/debrief/share/ShareApp';

import renderFFMenu from '../common/renderFFMenu';
renderFFMenu();

const isEnabled = isFeatureEnabled('debrief_demo_page');

if (isEnabled) {
    const rootNode = document.getElementById('debrief-app');
    if (rootNode) {
        const root = createRoot(rootNode);
        root.render(
            <React.StrictMode>
                <CssBaseline />
                <Provider store={createStore()}>
                    <DebriefApp />
                </Provider>
            </React.StrictMode>
        );
    }
}

if (isEnabled) {
    const rootNode = document.getElementById('debrief-share-app');
    if (rootNode) {
        const root = createRoot(rootNode);
        root.render(
            <React.StrictMode>
                <CssBaseline />
                <Provider store={createStore({ isShareApp: true })}>
                    <SharedDebriefApp />
                </Provider>
            </React.StrictMode>
        );
    }
}
